import React from "react";
import { Header, FooterLinks, DataPageContainer } from "../components";
import data from "../data/demographics_data.json";
import info from "../data/demographics_info.json";
import { getContent } from "./Helper";

function Demographics() {
  return (
    <DataPageContainer>
      <Header>Demographics</Header>
      {getContent(info, data)}
      <FooterLinks
        back={{ text: "view foreward", to: "/" }}
        next={{ text: "view school data", to: "school" }}
      />
    </DataPageContainer>
  );
}

export default Demographics;
